"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleRowInterestAmountFormula = void 0;
exports.getScheduleRowInterestAmount = getScheduleRowInterestAmount;
const general_formulas_1 = require("./general-formulas");
/*
 * Enumeration of ScheduleRowPaymentAmount formala implementation names
 */
var ScheduleRowInterestAmountFormula;
(function (ScheduleRowInterestAmountFormula) {
    ScheduleRowInterestAmountFormula[ScheduleRowInterestAmountFormula["DEFAULT"] = 0] = "DEFAULT";
})(ScheduleRowInterestAmountFormula || (exports.ScheduleRowInterestAmountFormula = ScheduleRowInterestAmountFormula = {}));
/**
 * Returns the specified draw fee formula implementation
 */
function getScheduleRowInterestAmount(formula) {
    switch (formula) {
        default:
            return default_scheduleRowInterestAmount;
    }
}
///////////////////////////
// Function Implementations
///////////////////////////
const default_scheduleRowInterestAmount = (params) => {
    if (typeof params.paymentIndex === 'number' && typeof params.startBalance === 'number'
        && typeof params.paymentRate === 'number' && typeof params.previousRow === 'object') {
        const outstandingBalance = params.paymentIndex == 0 ? params.startBalance : params.previousRow.endBalance || 0;
        if (params.paymentCount == 1) {
            return (0, general_formulas_1.toFixedNumber)(params.startBalance * (params.paymentRate / 100), 2);
        }
        else {
            return (0, general_formulas_1.toFixedNumber)(outstandingBalance * (params.paymentRate / 100), 2);
        }
    }
    return NaN;
};
//# sourceMappingURL=schedule-row-interest-amount-formula.js.map